var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogotipoCor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 207 39.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-8{fill:#007836;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill-rule:evenodd;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:#8bb31d;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2006.42,
    y1: 5068.33,
    x2: 2001.58,
    y2: 5045.53,
    gradientTransform: "translate(3905.72 -3764.53) rotate(67.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#057a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#128031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#298b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#499a22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#72ac17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#a3c30a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8d400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 7690.59,
    y1: 5177.24,
    x2: 7685.75,
    y2: 5154.43,
    gradientTransform: "translate(9146.96 -1456.63) rotate(136.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9625.11,
    y1: -556.07,
    x2: 9620.27,
    y2: -578.87,
    gradientTransform: "matrix(-0.85, -0.53, 0.53, -0.85, 8482.13, 4612.03)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 5183.19,
    y1: -3915.7,
    x2: 5178.35,
    y2: -3938.5,
    gradientTransform: "translate(3013.17 5788.09) rotate(-80.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 105.95,
    y1: -328.98,
    x2: 101.11,
    y2: -351.78,
    gradientTransform: "translate(-51.31 376.03) rotate(-3.62)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logotipo_cor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.1,29.41C9.84,33.67,3.7,32.05,0,25.32a17.13,17.13,0,0,0,4.56,7.89C9.7,37.44,13.26,32.22,15.1,29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.79,32.37c5.54,4.38,9.51-.64,11.33-3.65,4-6.55,10.92.45,5.14,5.84C16.84,37.74,8,37.47,3.79,32.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.17,19.37C2.35,15.94,1.72,9.62,6.75,3.82a17.26,17.26,0,0,0-5.81,7C-1.24,17.12,4.9,18.64,8.17,19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.46,9.81c-2.19,6.72,3.91,8.69,7.37,9.35,7.51,1.43,3.37,10.4-3.68,6.85C1,23.91-1.86,15.53,1.46,9.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.09,9.32C16.91,2.8,22.85.56,29.75,3.91A17.29,17.29,0,0,0,21.46.12C14.84-.35,15,6,15.09,9.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.59.35c-7-.36-7.38,6-7.12,9.54.56,7.63-9.17,6-7.57-1.78C8.84,3.53,16.21-1.37,22.59.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.87,13.09c6.72-.77,11,3.89,10.52,11.55a17.3,17.3,0,0,0,.39-9.1C35.74,9.22,29.93,11.71,26.87,13.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38,16.67c-2.31-6.68-8.36-4.58-11.51-3C19.62,17,17.52,7.4,25.28,6,29.88,5.12,37.2,10.11,38,16.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.67,25.56c2.31,6.35-1.22,11.63-8.79,12.92a17.25,17.25,0,0,0,9-1.74C33.5,33.28,29.73,28.21,27.67,25.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.78,37.21c5.95-3.8,2.5-9.2.25-11.9-4.9-5.88,4-10.18,7.19-3C36.12,26.63,33,34.9,26.78,37.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M171.36,24.53a6.51,6.51,0,0,1-5.29,2.34,7.39,7.39,0,0,1-7.27-6.95h17.69c0-7.48-5.19-12-10.62-12A10.85,10.85,0,0,0,155.28,19a10.78,10.78,0,0,0,10.79,11,10.13,10.13,0,0,0,7.68-3.11ZM165.87,11.1a7.23,7.23,0,0,1,6.78,5.72H159A7.32,7.32,0,0,1,165.87,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M78.8,29.53H75.37V16.73a8.77,8.77,0,1,1,17.53,0v12.8H89.47V16.61a5.34,5.34,0,1,0-10.67,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.21,8.07V11.3c-4.05-.37-6.62,1.59-6.62,5.64V29.53h-3.43V17C120.16,10.65,124.69,7.42,130.21,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M207,29.53c-4.9.57-8.3-2.33-8.3-7.69V4h3.44v4.5h4.78v3.31h-4.78V21.84c0,3.72,2.24,4.66,4.86,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M112.08,24.53a6.51,6.51,0,0,1-5.29,2.34,7.39,7.39,0,0,1-7.27-6.95h17.69c.05-7.48-5.19-12-10.62-12A10.85,10.85,0,0,0,96,19a10.78,10.78,0,0,0,10.79,11,10.11,10.11,0,0,0,7.68-3.11ZM106.59,11.1a7.23,7.23,0,0,1,6.78,5.72H99.72A7.32,7.32,0,0,1,106.59,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M67.23,24.53a6.53,6.53,0,0,1-5.29,2.34,7.4,7.4,0,0,1-7.28-6.95h17.7c0-7.48-5.19-12-10.63-12A10.85,10.85,0,0,0,51.15,19,10.78,10.78,0,0,0,61.94,30a10.11,10.11,0,0,0,7.67-3.11ZM61.73,11.1a7.23,7.23,0,0,1,6.79,5.72H54.87A7.31,7.31,0,0,1,61.73,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M141.9,8A10.7,10.7,0,0,0,131.31,19c0,6.3,4.7,11,10.51,11A8.83,8.83,0,0,0,149,26.54v2c0,3.8-2,8-7.4,8a7.21,7.21,0,0,1-5.3-2.1l-2.44,2.44a10.53,10.53,0,0,0,7.74,3c6.5,0,10.83-4.58,10.83-11.32V19C152.44,12.81,147.87,8,141.9,8Zm0,18.88c-3.92,0-7.11-3.39-7.11-7.81s3.19-7.88,7.11-7.88S149,14.65,149,19,145.78,26.83,141.9,26.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M187.65,16.83c-4.13-.65-5.32-1.19-5.32-2.7s2-3,4.79-3A5.57,5.57,0,0,1,191.64,13h3.74c-1-3.17-4-5-8.26-5-5.65,0-8.27,3.23-8.27,6.26,0,4,3.11,5.2,8.23,5.94s5.73,1.8,5.73,3.27c0,1.85-2,3.44-5.29,3.44a6.16,6.16,0,0,1-5.23-2.35h-3.81c1.17,3.5,4.58,5.59,9,5.59,5,0,8.65-2.66,8.65-6.88C196.17,18.47,192.32,17.57,187.65,16.83Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotipoCor);
export default __webpack_public_path__ + "static/media/logotipo_cor.d1e8b8f081a7cea4a8f65efaa9b2dc66.svg";
export { ForwardRef as ReactComponent };